/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Go_To_Previous_TitleInputs */



/**
* | output |
* | --- |
* | "Go to previous event" |
*
* @param {Video_Export_Preview_Go_To_Previous_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_go_to_previous_title = /** @type {((inputs?: Video_Export_Preview_Go_To_Previous_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Go_To_Previous_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aller a l'evenement precedent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum vorherigen Ereignis zurückkehren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai all'evento precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти к предыдущему событию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ir al evento anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("返回上一活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前のイベントへ戻る")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछले कार्यक्रम पर जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ir para o evento anterior")
	return /** @type {LocalizedString} */ ("Go to previous event")
});